import { GetterTree } from "vuex";
import { RootState, SubscriptionDescriptionAdminzoneState } from "@/types/store/adminzone";
import { SubscriptionDescriptionsData } from "@/types";

export const getters: GetterTree<SubscriptionDescriptionAdminzoneState, RootState> = {
  GET_SUBSCRIPTION_DESCRIPTIONS: (state): Array<SubscriptionDescriptionsData> => [...state.subscriptionDescriptions],
  GET_ACTIVE_SUBSCRIPTION_DESCRIPTIONS: (state): Array<SubscriptionDescriptionsData> => JSON.parse(JSON.stringify(state.subscriptionDescriptions.filter(subscriptionDescription => subscriptionDescription.deletedAt == null)))
}
